import {SecurityIndicesService} from "./service/SecurityIndicesService";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.indices`;
    return angular.module(moduleName, [])
                  .service(SecurityIndicesService.id, SecurityIndicesService)
                  .name;
}
